import React from 'react';
import { Link } from 'react-router-dom';
import OrderPriorities from './OrderPriorities';

export default function OrderManagement() {
  return <main className="max-w-7xl mx-auto p-4 md:p-6">
    <header className="flex flex-wrap items-center justify-between gap-3 mb-4"><h1 className="text-2xl md:text-3xl font-semibold">Order Management</h1><Link className="border rounded px-4 py-2 text-indigo-700" to="/">Back to Dashboard</Link></header>
    <OrderPriorities />
  </main>;
}
